import React, { Component } from "react";
import VerticalFillLayout from "../../layout/fill/VerticalFillLayout";
import CenterLayout from "../../layout/center/CenterLayout";

export default class VerticalFillLayoutDemo extends Component {
  render() {
    return (
      <VerticalFillLayout hgap={20}>
        <CenterLayout className="bg1">HorizontalFill</CenterLayout>
        <CenterLayout className="bg2">HorizontalFill</CenterLayout>
      </VerticalFillLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/demo.verticalFillLayout.js